
"use strict"

// import componentName from './path/to/componentName'
import expand from './components/expand'
import asyncLoadOnScroll from './utility/asyncLoadOnScroll'
import videoLightbox from './components/video'
import logoCarousel from './components/logoCarousel'
import relatedProducts from './components/relatedProducts'
import productCarousel from './components/productCarousel'
import galleryCarousel from './components/galleryCarousel'
import './components/tabbedContent'
import './components/tabbedContent'
import './components/elasticPress'
import './components/modal'
import './components/newsFilter'
import './components/feedbackModal'

import './components/navigation'
import './components/load-row'

// Animations
import './animations/gsapSetup'
import './animations/headings'
import './animations/fullImagePin'
import './animations/footerWaves'
import './animations/hero'

//Utility
import './utility/smoothScroll'


logoCarousel()
relatedProducts()
productCarousel()
galleryCarousel()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

expand('.mobile-menu__nolink', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')